'use client';

import React from 'react';
import { IndustryTiles } from '@sapientpro/sapientpro-data-models';
import classNames from 'classnames';
import styles from './Industries.module.scss';
import IndustryCard from './IndustryCard';
import AnimatedTitle from '../../../components/AnimatedTitle';

interface IProps {
  industries: Array<IndustryTiles>;
}

const Industries = ({ industries }: IProps) => (
  <div className={styles.industries}>
    <h3 className={classNames('sectionTitle', styles.title)}>
      <AnimatedTitle title='Core **industry** expertise' />
    </h3>
    <div className={styles.list}>
      {industries.map(industry => (
        <IndustryCard
          industry={industry}
          key={industry.id}
        />
      ))}
    </div>
  </div>
);

export default Industries;
